import styled from 'styled-components'
import { Dropdown } from 'common-components'

export const PlaybackSpeedDropdownRoot = styled(Dropdown)`
  flex-shrink: 0;
  border-radius: 4px;
  width: auto;
  height: 24px;
  & > div {
    padding: 0;
    border: none;
    background-color: transparent;
    height: 100%;
    &:hover {
      &::before {
        content: none;
      }
      border: none;
    }
  }
`
